import "bootstrap/dist/css/bootstrap.min.css";
import { addExperiences } from "./components/addExperience";
import { addProjects } from "./components/addProjects";
import { addScrollToTopButton } from "./components/addScrollToTopButton";
import { addWaveDecor } from "./components/addWaveDecor";
import "./styles.css";

addScrollToTopButton();
addWaveDecor();
addExperiences();
addProjects();
